export default __webpack_public_path__ + "static/media/false_negative_rate.93ed667b.jpeg";